module.exports = __webpack_public_path__ + "img/male_introduction_1.c8167fdd.png";